import React from 'react';
import { Check } from 'lucide-react';

const Breadcrumb = ({ currentStep }) => {
  const steps = [
    { id: 1, name: 'Programme', icon: '📋' },
    { id: 2, name: 'Options', icon: '⚙️' },
    { id: 3, name: 'Budget', icon: '📄' }
  ];

  return (
    <div className="breadcrumb">
      <div className="breadcrumb-container">
        {steps.map((step, index) => (
          <React.Fragment key={step.id}>
            <div className={`breadcrumb-item ${
              step.id === currentStep ? 'active' : 
              step.id < currentStep ? 'completed' : 'inactive'
            }`}>
              <div className="breadcrumb-icon" data-testid={`breadcrumb-step-${step.id}`}>
                {step.id < currentStep ? <Check size={20} /> : step.icon}
              </div>
              <div className="breadcrumb-label">{step.name}</div>
            </div>
            {index < steps.length - 1 && (
              <div className="w-8 h-0.5 bg-[#d8dde5]"></div>
            )}
          </React.Fragment>
        ))}
      </div>
    </div>
  );
};

export default Breadcrumb;